import { render, staticRenderFns } from "./DealerHospitalRelation_list.vue?vue&type=template&id=5fa392fc&scoped=true"
import script from "./DealerHospitalRelation_list.vue?vue&type=script&lang=js"
export * from "./DealerHospitalRelation_list.vue?vue&type=script&lang=js"
import style0 from "./DealerHospitalRelation_list.vue?vue&type=style&index=0&id=5fa392fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa392fc",
  null
  
)

export default component.exports